import { IAPIRequestMetaData } from "redux/_core/api/types";
import { IUser, IVesselUser } from "./@types";
import { getType } from "typesafe-actions";
import userActions from "./actions";
import { commonUtils } from "redux/_common";

export type IConsoleUsersListResponse = {
	items: IUser[];
	page: number;
	pageSize: number;
	total: number;
	totalPages: number;
};

const consoleUsersBaseUrl = () =>
	`${commonUtils.getAPIBaseUrl()}/api/console-users`;

const userAPIs = {
	createUser(
		user: Pick<IVesselUser, "name" | "email" | "roleCategory">
	): IAPIRequestMetaData<IUser> {
		return {
			url: consoleUsersBaseUrl(),
			method: "POST",
			feature: getType(userActions.commands.userCreate),
			body: {
				name: user.name,
				email: user.email,
				roleCategory: user.roleCategory,
			},
		};
	},
	updateUser(
		userId: string,
		user: Partial<Pick<IUser, "name" | "roleCategory" | "staffId">>
	): IAPIRequestMetaData<IUser> {
		return {
			url: consoleUsersBaseUrl(),
			feature: getType(userActions.commands.userUpdate),
			method: "PATCH",
			queryParams: {
				id: userId,
			},
			body: user,
		};
	},
	deleteUser(userId: string): IAPIRequestMetaData<any> {
		return {
			url: consoleUsersBaseUrl(),
			feature: getType(userActions.commands.userDelete),
			method: "DELETE",
			queryParams: {
				id: userId,
			},
		};
	},
	loadUserList(
		itemsPerPage: number = 10,
		pageNumber: number = 1,
		isPaginated: boolean = true
	): IAPIRequestMetaData<IConsoleUsersListResponse> {
		return {
			url: consoleUsersBaseUrl(),
			method: "GET",
			feature: getType(userActions.commands.userListLoad),
			queryParams: {
				page: pageNumber,
				pageSize: isPaginated ? itemsPerPage : 200,
			},
		};
	},
};

export default userAPIs;
